import { Repository, EntityRepository } from 'typeorm';
import { Stock } from '../../stock/stock.entity';


@EntityRepository(Stock)
export class StockRepository extends Repository<Stock>{

    
    
}
